
<p-card> 
    <div class="field col-12">
        <label for="days" style="margin-right: 10px;">Days back to pull:</label>
        <p-inputNumber inputId="days" [(ngModel)]="days" [min]="0" [max]="365"></p-inputNumber>
        <br>
        <p-button (onClick)="PopulateData($event)" label="Pull data"></p-button>
    </div>
    <!--<h5>Users</h5>
    <p-progressSpinner *ngIf="usersLoading"></p-progressSpinner>
    <div *ngFor="let user of users" class="field-checkbox">
        <p-checkbox name="group1" value="user" [value]="user"  [(ngModel)]="selectedUsers" [inputId]="user.key"></p-checkbox>
        <label [for]="user.key">{{user.name}}</label>
    </div>-->
    
    <h5>Strains</h5>
    <p-progressSpinner *ngIf="strainsLoading"></p-progressSpinner>
    <div *ngFor="let strain of strains" class="field-checkbox">
        <p-checkbox name="group2" value="category" [value]="strain"  [(ngModel)]="selectedStrains" [inputId]="strain.key"></p-checkbox>
        <label [for]="strain.key">{{strain.name}}</label>
    </div>
    
    <h5>Start Date</h5>
    <div class="field">
        <p-calendar [(ngModel)]="selectedStartDate" [showClear]="true" inputId="selectedStartDate"></p-calendar>
    </div>
    
    <h5>End Date</h5>
    <div class="field">
        <p-calendar [(ngModel)]="selectedEndDate" [showClear]="true" inputId="selectedStartDate"></p-calendar>
    </div>
    
    <div class="field">
        <p-button (onClick)="Save($event)" label="Save"></p-button>
    </div>
</p-card>
